/**
 * DWEEB — https://dweeb.faizo.net — our companion visual builder for Discord
 * webhook messages (same author). RoleLogic links out to it from the
 * dashboard sidebar, the homepage, and the footer; links carry UTM tags so
 * conversions are attributable without any personal data.
 */

export const DWEEB_URL: string =
  (import.meta.env.VITE_DWEEB_URL as string | undefined) ??
  "https://dweeb.faizo.net";

/** DWEEB link tagged with the referral surface (`dashboard`, `homepage`, `footer`). */
export function dweebPromoUrl(medium: string): string {
  return `${DWEEB_URL}/?utm_source=rolelogic&utm_medium=${encodeURIComponent(medium)}`;
}

/**
 * Shared premium: RoleLogic and DWEEB sell the same Stripe subscriptions, and
 * DWEEB derives its per-server tier from a subscription's entitlement slots —
 * the same slot counts RoleLogic's plans grant. Thresholds mirror
 * `Tier::from_slots` in DWEEB's `server/src/entitlement.rs`:
 * 130+ slots → DWEEB Pro, 36+ → DWEEB Plus, below that → Free.
 * Keep in sync if DWEEB rebalances its tier split.
 */
export type DweebTier = "plus" | "pro";

export function dweebTierForSlots(slots: number): DweebTier | null {
  if (slots >= 130) return "pro";
  if (slots >= 36) return "plus";
  return null;
}
